import apiData from './api.json';

export default apiData;